<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">
        <span>Purchase Confirmed!</span>
	</div>
    <img class="line" src="/assets/img/lobby/ellipse.svg">
    <div class="instructions">
        <div class="golds item" (click)="goToAnotherPage('freeplay')">
            <img src="/assets/icon/chips/gold_chip.webp">
            <span>Use your gold <br> to play in our Freeplay games!</span>
        </div>
        <div class="sweepsbucks item" (click)="goToAnotherPage('sweepstakes')">
            <img src="assets/img/sweep/money.webp">
            <span>Use Sweeps Coins in Sweepstakes games & redeem!</span>
        </div>
    </div>
	<div class="sopo-popup-button-container">
		<div class="sopo-popup-green-button clickable" (click)="close()">Ok</div>
		<div class="sopo-popup-red-button clickable" (click)="doNotShowSweeps()">Don't Show This Again</div>
	</div>
</div>
